import { join } from "node:path";

export function getGitIgnoredFolder(projectFolder = "") {
  return join(projectFolder, ".wix");
}

export function getTypesDir(projectFolder: string) {
  return join(getGitIgnoredFolder(projectFolder), "types");
}

export function getPageTypesDir(projectFolder: string, pageId: string) {
  return join(getTypesDir(projectFolder), pageId);
}

export function getPageConfigFilename(projectFolder: string, pageId: string) {
  return join(getPageTypesDir(projectFolder, pageId), `jsconfig.json`);
}

export function getBackendConfigPath(projectFolder: string) {
  return join(getTypesDir(projectFolder), "backend", "jsconfig.json");
}

export function getPublicConfigPath(projectFolder: string) {
  return join(getTypesDir(projectFolder), "public", "jsconfig.json");
}

export function getSourceFolder(projectFolder: string) {
  return join(projectFolder, "src");
}

export function getBackendDTSPath(projectFolder: string): string {
  return join(getTypesDir(projectFolder), "backend.d.ts");
}

export function getPageElementsMapDTSFilename(pageId: string) {
  return `${pageId}.d.ts`;
}
